import { apiFetch, ApiError } from "../../api/client";

const SUBMIT_TIMEOUT_MS = 15_000;

/**
 * Как в звонилке: браузер → свой API (same-origin),
 * API сохраняет копию и шлёт в Formspree.
 * Прямой fetch на formspree.io из браузера часто даёт «Failed to fetch» (CORS/блок).
 */
export async function submitBoardBugReport(
  payload: Record<string, string>
): Promise<{ id?: string; savedOnServer: boolean; formspree?: boolean }> {
  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), SUBMIT_TIMEOUT_MS);

  try {
    const data = await apiFetch<{
      ok: boolean;
      id?: string;
      saved?: boolean;
      formspree?: boolean;
    }>("/api/v1/bug-report", {
      method: "POST",
      json: payload,
      signal: controller.signal,
    });

    if (!data.ok) {
      throw new ApiError("Сервер не принял отчёт", 502);
    }

    return {
      id: data.id,
      savedOnServer: Boolean(data.saved),
      formspree: data.formspree,
    };
  } catch (e) {
    if (e instanceof Error && e.name === "AbortError") {
      throw new ApiError(
        "Сервер долго не отвечает. Проверьте интернет и попробуйте снова.",
        408
      );
    }
    throw e;
  } finally {
    clearTimeout(timeoutId);
  }
}
